import type { AttestationDTO, StagiaireDTO } from '@/features/api/extranet/dto/Demande/DR'
import { DEMANDE_STORE } from '@/features/interface/demande/shared/components/DemandeContent/DemandeContent.types'
import { storeToRefs } from 'pinia'
import { computed, inject } from 'vue'

export type Attestation = StagiaireDTO & AttestationDTO & { index: number }
export const useModuleAttestations = (moduleIndex: number) => {
  const store = inject(DEMANDE_STORE)!.getStore('MODEL_DR')
  const { model, meta, readonly } = storeToRefs(store)
  const { setupArrayUpdaterWithKey } = store
  const module = computed(() => {
    return model.value!.modules![moduleIndex]!
  })

  const attestations = computed<Attestation[]>(() => {
    return model
      .value!.attestations!.map((attestation, index) => ({ ...attestation, index }))
      .filter((attestation) => attestation.idModule === module.value.idModule)
      .map((attestation) => {
        const stagiaire = model.value!.stagiaires!.find((s) => {
          return s.idIndividuAdhEtablissement === attestation.idSalarie
        })!
        return {
          ...stagiaire,
          ...attestation,
        }
      })
  })

  const updateAttestations = setupArrayUpdaterWithKey<AttestationDTO>('attestations')

  const moduleReadonly = computed(() => readonly.value || module.value.estTraite !== true)

  return { module, attestations, meta, updateAttestations, readonly, moduleReadonly }
}
